import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=827eeba4&scoped=true"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"
import style0 from "./Link.vue?vue&type=style&index=0&id=827eeba4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827eeba4",
  null
  
)

export default component.exports